import React from 'react';
import Button from './button';

export default function Accent(props) {
  return <Button variant="accent" {...props} />;
}
